import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';

import { colors, icons } from '@cobliteam/base-components/src/styles';

const ChecklistItemIconButton = withStyles({
  root: {
    padding: 0,
    height: icons.size.small,
    width: icons.size.small,
    marginLeft: '20px',

    '& svg': {
      color: colors.gray.default,
    },

    '&:hover': {
      backgroundColor: 'transparent',

      '& svg': {
        color: colors.gray.dark,
      },
    },
  },
})(IconButton);

export default ChecklistItemIconButton;
